export function useNotifications() {
  function show(title: string, body: string) {
    const native = (window as any).pexitalk?.notifications
    if (native) {
      native.show(title, body)
    } else if ('Notification' in window) {
      if (Notification.permission === 'granted') {
        new Notification(title, { body })
      } else {
        Notification.requestPermission().then((p) => {
          if (p === 'granted') new Notification(title, { body })
        })
      }
    }
  }
  return { show }
}
